// @flow
import * as React from 'react';
import Video from '@components/Video';
import { useBreakpoint, useWindowSize } from '@hooks';
import theme from '@theme';

import type { Props } from './types';

import { StyledWrapper, StyledHorizontalMask } from './styles';

const TeaserVideo = ({
  src, className, type, posterUrl
}: Props): React.Node => {
  const isDesktop = useBreakpoint('desktop');
  const { width } = useWindowSize();
  const { breakpoints } = theme;

  const maxHeight = 35;
  let horizontalMaskSize = 0;

  if (isDesktop) {
    horizontalMaskSize = maxHeight;
  } else if (width > breakpoints.tablet) {
    const scale = (width - breakpoints.tablet) / (breakpoints.desktop - breakpoints.tablet);
    horizontalMaskSize = maxHeight * scale;
  }

  return (
    <StyledWrapper className={className}>
      <StyledHorizontalMask size={horizontalMaskSize} />
      <Video url={src} type={type || 'video/mp4'} posterUrl={posterUrl} />
      <StyledHorizontalMask size={horizontalMaskSize} bottom />
    </StyledWrapper>
  );
};

export default TeaserVideo;
